import { CustomerQuoteDetailsTab } from 'quotes/components/CustomerQuoteDetails/CustomerQuoteDetails';

import { AlternateOrderValidationWarning } from './enums';

export const ORDER_WARNING_TAB_MAP: Record<string, CustomerQuoteDetailsTab> = {
  [AlternateOrderValidationWarning.MISSING_AR_NUMBER]: CustomerQuoteDetailsTab.BASE_INFORMATION,
  [AlternateOrderValidationWarning.MISSING_ISR_EMPLOYEE]: CustomerQuoteDetailsTab.BASE_INFORMATION,
  [AlternateOrderValidationWarning.MISSING_OSR_EMPLOYEE]: CustomerQuoteDetailsTab.BASE_INFORMATION,
  [AlternateOrderValidationWarning.CUSTOMER_NOTE_TOO_LONG]: CustomerQuoteDetailsTab.CUSTOMER_NOTE,
  [AlternateOrderValidationWarning.PURCHASE_ORDER_NUMBER_TOO_LONG]:
    CustomerQuoteDetailsTab.BASE_INFORMATION,
  [AlternateOrderValidationWarning.INACTIVE_BILL_TO_PROJECT_LINK]:
    CustomerQuoteDetailsTab.BASE_INFORMATION,
  [AlternateOrderValidationWarning.INACTIVE_SHIP_TO_PROJECT_LINK]:
    CustomerQuoteDetailsTab.BASE_INFORMATION,
};
